import { Directive } from '@angular/core';

@Directive({
  selector: '[libPmtDataTable]'
})
export class PmtDataTableDirective {

  constructor() { }

}
